module.exports = __webpack_public_path__ + "fonts/fa-solid-900.0bff33a5.ttf";